import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { FormControl, UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'app-search-mobile',
  templateUrl: './search-mobile.component.html',
  styleUrls: ['./search-mobile.component.scss'],
})
export class SearchMobileComponent {
  @Input()
  show: boolean = false;

  @Output()
  formSubmit: EventEmitter<void> = new EventEmitter();

  @HostBinding('class.show')
  get showClass(): boolean {
    return this.show;
  }

  innerForm = this.formBuilder.group({
    searchQuery: new FormControl('', {
      nonNullable: true,
    }),
  });

  constructor(private formBuilder: UntypedFormBuilder) {}
}
